import Vue from "vue";
import VueRouter from "vue-router";
import home from "../views/home/home.vue";
// import homemonterrey from "../views/home/homemonterrey.vue";
import confirm from "../views/confirm/confirm.vue";
import confirmmonterrey from "../views/confirm/confirmmonterrey.vue";
import productsServices from "../views/product-or-service/product-or-service.vue";  
import ContactDetailsGs from "../views/home/contactDetailsGs.vue";

Vue.use(VueRouter);

const routes = [
  {
    path:'/',
    name:'home',
    component:home,
  },
  {
    path:'/confirmations',
    name:'confirm',
    component:confirm,
  },
  {
    path:'/datos/proveedoresgruposalinas',
    name:'proveedoresgruposalinas',
    component:ContactDetailsGs,
  },
  {
    path:'/monterrey/confirmations',
    name:'confirm monterrey', 
    component:confirmmonterrey,
  },
  {
    path:'/products-services',
    name:'products-services',
    component:productsServices, 
  },
  {
    path: '*',
    redirect: '/'
  }
];

export const router = new VueRouter({
  routes,
});

